const LoadingDots = ({ loading = true }: { loading?: boolean }) => {
  if (!loading) return null;
  return (
    <div className="loading-dots py-4">
      <div className="dot dot-1 rounded-full animate-bounce"></div>
      <div className="dot dot-2 rounded-full animate-bounce"></div>
      <div className="dot dot-3 rounded-full animate-bounce"></div>
    </div>
  );
};

export default LoadingDots;
